import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Alert, TextField } from "@mui/material";

import { useAppDispatch } from "@/hooks";
import { passwordReset } from "../../auth/slice";
import routes from "@/constants/routes";
import AuthLayout from "@/features/auth-layout/AuthLayout";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowTurnBackwardIcon, ResetPasswordIcon } from "@hugeicons/core-free-icons";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Correo no válido").required("Campo requerido"),
});

const ResetPassword = () => {
  const [emailSent, setEmailSent] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema,
    onSubmit: async ({ email }) => {
      await dispatch(passwordReset(email));
      setEmailSent(true);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <AuthLayout
        icon={<HugeiconsIcon icon={ResetPasswordIcon} size={50} strokeWidth={1} color="#015FEE" />}
        title="Cambia tu contraseña"
        subtitle="Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña."
        primaryAction={{
          label: "Cambiar contraseña",
          onClick: formik.submitForm,
          loading: formik.isSubmitting,
        }}
        secondaryAction={{
          label: "Iniciar sesión",
          onClick: () => navigate(routes.login),
          btnIcon: <HugeiconsIcon icon={ArrowTurnBackwardIcon} />,
        }}
      >
        {emailSent && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Email enviado, revisa tu bandeja de entrada
          </Alert>
        )}

        <TextField
          fullWidth
          name="email"
          type="email"
          label="Correo"
          margin="normal"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          onBlur={formik.handleBlur}
        />
      </AuthLayout>
    </form>
  );
};

export default ResetPassword;
